var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Пользовательское соглашение!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "red" }, [
                    _vm._v("ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn_bordered ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n            Прочитал\n          ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "form_upload",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("section", { staticClass: "contact" }, [
            _c("div", { staticClass: "containerCustom" }, [
              _c("div", { staticClass: "contact__inner" }, [
                _c("div", { staticClass: "contact__header" }, [
                  _c("h2", { staticClass: "contact__title" }, [
                    _vm._v("Оставьте заявку и наш менеджер вам перезвонит"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact__content" }, [
                  _c(
                    "form",
                    { staticClass: "contact__form" },
                    [
                      _c(
                        "div",
                        { staticClass: "contact__box" },
                        [
                          _c("v-text-field", {
                            staticClass: "contact__input",
                            attrs: {
                              rules: _vm.nameRules,
                              required: "",
                              solo: "",
                              placeholder: "Имя",
                            },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: " contact__input",
                            attrs: {
                              rules: _vm.tel_inputRules,
                              required: "",
                              solo: "",
                              placeholder: "Телефон",
                              oninput:
                                "this.value = this.value.replace(/[^\\d]/g,'');",
                            },
                            model: {
                              value: _vm.tel_input,
                              callback: function ($$v) {
                                _vm.tel_input = $$v
                              },
                              expression: "tel_input",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-textarea", {
                        staticClass: "contact__textaria",
                        attrs: {
                          rules: _vm.messageRules,
                          name: "message",
                          filled: "",
                          "auto-grow": "",
                          counter: "",
                          solo: "false",
                          "row-height": "24",
                          placeholder: "Комментарий",
                        },
                        model: {
                          value: _vm.message,
                          callback: function ($$v) {
                            _vm.message = $$v
                          },
                          expression: "message",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "contact__box" },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              rules: [
                                function (v) {
                                  return (
                                    !!v ||
                                    "Вы должны подтвердить прочтение соглашения!"
                                  )
                                },
                              ],
                              required: "",
                              color: "red",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "contact__label" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "contact__text" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$refs.modal_contents_agree.modal_open(
                                                      "scroll_false"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("соглашение")]
                                            ),
                                            _vm._v(
                                              " на обработку персональных данных\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.checkbox,
                              callback: function ($$v) {
                                _vm.checkbox = $$v
                              },
                              expression: "checkbox",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: " " },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "px-30 btn_red contact__send",
                              attrs: { disabled: !_vm.valid },
                              on: { click: _vm.sendForm },
                            },
                            [_c("span", [_vm._v("Оставить заявку")])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }